import {
  WestNegevLoginStepFormFieldsEnum,
  yupLanding,
} from "@ryde/utils-landings";

export const useYupLoginLandingWestNegevValidationSchema = () => {
  const yupLoginLandingWestNegevValidationSchema = {
    [WestNegevLoginStepFormFieldsEnum.PhoneMobile]: yupLanding
      .string()
      .required(),
  };
  return { yupLoginLandingWestNegevValidationSchema };
};
